import React, { Fragment, FC } from 'react';
import { Card, CardContent, CardHeader, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { usePublicClient, useContent } from 'hooks';
import { Events } from 'analytics';

import { getPhoto, hasCreator } from '../helpers';
import { MetaPublic, UserPublic } from '../partials';
import { Description, ExternalLink, Image, Photo, Provider, Title } from '../widgets';

const useStyles = makeStyles(theme => ({
  card: {
    marginBottom: theme.spacing(3),
  },
  cardHeader: {
    paddingBottom: theme.spacing(0.5),
    paddingTop: theme.spacing(0.5),
  },
}));

const UrlPublic: FC = () => {
  const client = usePublicClient();
  const content = useContent();
  const classes = useStyles();
  const { content_object } = content;
  const { url_metadata } = content_object;

  if (!url_metadata) {
    return null;
  }

  const { title, description } = url_metadata;
  const photo = getPhoto(content);
  const hasPostCreator = hasCreator(content);

  function handleTracking() {
    window?.analytics?.track(Events.PublicPostClicked);
  }

  function renderCardHeader() {
    const provider = (
      <ExternalLink>
        <Provider content={content} />
      </ExternalLink>
    );

    return <CardHeader className={classes.cardHeader} title={provider} />;
  }

  return (
    <Card className={classes.card}>
      {hasPostCreator && (
        <Fragment>
          {client.public_post_details && <UserPublic />}
          <Divider />
        </Fragment>
      )}
      {renderCardHeader()}
      <ExternalLink onClick={handleTracking}>
        {photo ? <Photo disableViewer photo={photo} /> : <Image content={content} />}
      </ExternalLink>
      <CardContent>
        <ExternalLink onClick={handleTracking}>
          <Title title={title} />
          <Description description={description} />
        </ExternalLink>
      </CardContent>
      <MetaPublic />
    </Card>
  );
};

export default UrlPublic;
